import { LitigationAreas, LitigationStages } from "../../Admin/LeadsManagement/shared/Constants";

export interface LitigationArea {
  area: LitigationAreas;
  name: string;
  stages: LitigationStage[];
}

export interface LitigationStage {
  stage: LitigationStages;
  name: string;
}

export const Areas: LitigationArea[] = [
  {
    area: LitigationAreas.LitigationFunnelState,
    name: "Litigation Funnel State",
    stages: [
      { stage: LitigationStages.ServiceConfirmation, name: "Service Confirmation" },
      { stage: LitigationStages.ServiceOfWrittenDiscovery, name: "Service of Written Discovery" },
      { stage: LitigationStages.DiscoveryProcessPRequestsToD, name: "Discovery Process: P Requests to D" },
      { stage: LitigationStages.PreparePostDiscoveryCaseEvaluationMemo, name: "Prepare Post-Discovery Case Evaluation Memo" },
      { stage: LitigationStages.InitialDisclosuresToDefendant, name: "Initial Disclosures to Defendant" },
      { stage: LitigationStages.InitialDisclosuresToPlaintiff, name: "Initial Disclosures to Plaintiff" },
    ],
  },
  {
    area: LitigationAreas.DiscoveryResponses,
    name: "Discovery Responses",
    stages: [
      { stage: LitigationStages.DiscoveryProcessPResponsesToD, name: "Discovery Process: P Responses to D" },
    ],
  },
  {
    area: LitigationAreas.DefendantsDeposition,
    name: "Defendant's Deposition",
    stages: [
      { stage: LitigationStages.DefendantsDeposition, name: "Defendant's Deposition" },
    ],
  },
  {
    area: LitigationAreas.PlaintiffDepo,
    name: "Plaintiff’s Deposition",
    stages: [
      { stage: LitigationStages.PlaintiffsDeposition, name: "Plaintiff’s Deposition" },
      { stage: LitigationStages.ObtainDepositionTranscript, name: "Obtain Deposition Transcript" },
    ],
  },
  {
    area: LitigationAreas.Pleadings,
    name: "Pleadings",
    stages: [
      { stage: LitigationStages.Pleadings, name: "Pleadings" },
    ],
  },
  {
    area: LitigationAreas.CaseManagementConference,
    name: "CMC",
    stages: [
      { stage: LitigationStages.PleadingCaseManagementConference, name: "CMC" },
    ],
  },
  {
    area: LitigationAreas.Manual,
    name: "Manual",
    stages: [
      { stage: LitigationStages.Manual, name: "Manual" },
    ],
  },
  {
    area: LitigationAreas.OutsideTrigger,
    name: "Outside Trigger",
    stages: [
      { stage: LitigationStages.DiscoveryRequestSet2, name: "Discovery Request Set 2" },
      { stage: LitigationStages.DiscoveryRequestSet3, name: "Discovery Request Set 3" },
      { stage: LitigationStages.MotionToCompel, name: "Motion to Compel" },
      { stage: LitigationStages.ResponseToOppositionToMotion, name: "Response to Opposition to Motion" },
      { stage: LitigationStages.DepositionObjection, name: "Deposition Objection" },
      { stage: LitigationStages.PleadingsNoResponseFromDefendant, name: "Pleadings: No Response from Defendant" },
      { stage: LitigationStages.DemurrerOpposition, name: "Demurrer Opposition" },
      { stage: LitigationStages.InitialTrialSettingConferenceTSC, name: "Initial Trial Setting Conference (TSC)"},
      { stage: LitigationStages.UpdateCaseTeamsAndServiceList, name: "Update Case Teams and Service List" },
      { stage: LitigationStages.MeetAndConferSupplemental, name: "Meet and Confer (Supplemental)" },
    ],
  },
  {
    area: LitigationAreas.OutsideSingle,
    name: "Outside Single",
    stages: [
      { stage: LitigationStages.ServeInitialDisclousureDemand, name: "Serve Initial Disclosure Demand" },
      { stage: LitigationStages.NegotiationsLitigationArbitration, name: "Negotiations / Litigation / Arbitration" },
    ],
  },
];

export const MediationAreas: LitigationArea[] = [
  {
    area: LitigationAreas.Mediation,
    name: "Mediation",
    stages: [
      { stage: LitigationStages.SendListOfMediatorsToOC, name: "Send List of Mediators to OC" },
      { stage: LitigationStages.ConfirmOrFollowUpWithOCOnMediatorSelection, name: "Confirm or Follow Up with OC on Mediator Selection" },
      { stage: LitigationStages.ResearchAndUpdateMediatorInformation, name: "Research and Update Mediator Information" },
      { stage: LitigationStages.RequestDatesFromMediator, name: "Request Dates from Mediator" },
      { stage: LitigationStages.SendProposedMediationDatesToClientAndToOC, name: "Send Proposed Mediation Dates to Client and to OC" },
      { stage: LitigationStages.ConfirmMediationDateWithTheOpposingCounselAndScheduleIt, name: "Confirm Mediation Date with the Opposing Counsel and Schedule it" },
      { stage: LitigationStages.SendAndSignMediationNotice, name: "Send and Sign Mediation Notice" },
      { stage: LitigationStages.ObtainAndCalendarMediationDeadlines, name: "ENTER DATES IN CUSTOM FIELD - Obtain and Calendar Mediation Deadlines" },
      { stage: LitigationStages.DraftMediationBrief, name: "Draft Mediation Brief" },
      { stage: LitigationStages.ReviewOfMediationBrief, name: "Review of Mediation Brief" },
      { stage: LitigationStages.SubmitMediationBrief, name: "Submit Mediation Brief" },
      { stage: LitigationStages.ScheduleMediationPrepCall, name: "Schedule Mediation Prep Call" },
      { stage: LitigationStages.AttendMediation, name: "Attend Mediation" },
      { stage: LitigationStages.ProvidePostMediationFeedbackOnMediator, name: "Provide Post-Mediation Feedback on Mediator" },
    ],
  },
];
